import { Box, Typography, Grid, Card, CardContent } from "@mui/material";
import React from "react";
import PersonIcon from "@mui/icons-material/Person";
import { theme } from "../../Assets/Theme/theme";
import ExploreIcon from "@mui/icons-material/Explore";

function Overview({ data }) {
  const stats = [
    {
      label: "Registered users",
      value: data?.usercount || 0,
      color: theme.colors.blue,
      icon: (
        <PersonIcon
          sx={{ color: theme.colors.blue, position: "relative", top: 4 }}
        />
      ),
    },
    {
      label: "Guest users",
      value: data?.guestCount || 0,
      color: theme.colors.green,
      icon: (
        <PersonIcon
          sx={{ color: theme.colors.green, position: "relative", top: 4 }}
        />
      ),
    },
    {
      label: "Experiences",
      value: data?.experienceCount || 0,
      color: theme.colors.orange,
      icon: (
        <ExploreIcon
          sx={{ color: theme.colors.orange, position: "relative", top: 4 }}
        />
      ),
    },
  ];

  return (
    <Box>
      <Typography
        style={{ fontSize: "20px", marginBottom: "32px" }}
        gutterBottom
        fontWeight={700}
        color={theme.colors.text}
      >
        Overview
      </Typography>
      <Grid container spacing={2}>
        {stats.map((stat, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                textAlign: "center",
                boxShadow: "0px 1px 10px 4px rgba(0, 0, 0, 0.1)",
                borderRadius: "16px",
                height: "240px",
                alignContent: "center",
              }}
            >
              <CardContent>
                <Typography
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: 1,
                    fontSize: "16px",
                    fontWeight: 700,
                  }}
                  fontWeight={600}
                >
                  <Box
                    sx={{
                      marginRight: "8px",
                      fontSize: "20px",
                    }}
                  >
                    {stat.icon}
                  </Box>
                  {stat.label}
                </Typography>
                <Typography
                  sx={{
                    color: stat.color,
                    fontWeight: 700,
                    fontSize: "72px",
                  }}
                >
                  {stat.value}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default Overview;
